import React from "react";
import { connect } from "react-redux";
import { Link } from "gatsby";
import styled from "@emotion/styled";
import MutationCard from "components/MutationCard";
import { loadMutations } from "modules/playground/action";
import { getMutations } from "modules/playground/selectors";
import { isLoggedIn } from "modules/session/selectors";
import dayjs from "dayjs";

const Container = styled.div`
`;

const Back = styled.div`
  display: flex;
  flex-direction: row;

  p {
    font-size: 18px;
    padding-left: 1em;
    font-weight: bold;
    margin-top: 0px;
    color: white;
  }
`;

function MutationPage(props) {
  React.useState(() => {
    if (props.isLoggedIn) {
      props.loadMutations();
    }
  }, []);

  const mutations = props.mutations ? props.mutations : "";

  return (
    <Container>
      <Link to="/play">
        <Back>
          <svg
            width="15"
            height="26"
            viewBox="0 0 15 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.9932 1.47998L2.48001 12.9886L12.9895 24.4581"
              stroke="white"
              stroke-width="2"
            />
          </svg>
          <p>History</p>
        </Back>
      </Link>
      {Object.values(mutations).map(items =>
        items.amount > 0 ? (
          <MutationCard
            plus
            exhibitor={items.party.name}
            point={items.amount}
            time={dayjs(items.created_at).format("HH:mm")}
          />
        ) : (
          <MutationCard
            exhibitor={items.party.name}
            point={items.amount}
            time={dayjs(items.created_at).format("HH:mm")}
          />
        )
      )}
    </Container>
  );
}

const withConnect = connect(
  state => ({
    mutations: getMutations(state),
    isLoggedIn: isLoggedIn(state),
  }),
  { loadMutations }
);

export default withConnect(MutationPage);
